var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"paga-list flex"},[_c('div',{staticClass:"pag-item"},[_vm._v("2")])])])
}]

export { render, staticRenderFns }